import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../useApi";
import type { ProjectSummary } from "../types";

export default function NewProjectPage() {
  const { call } = useApi();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [jiraProjectKey, setJiraProjectKey] = useState("");
  const [jiraBaseUrl, setJiraBaseUrl] = useState("https://vaisala.atlassian.net");
  const [error, setError] = useState<string | undefined>();
  const [saving, setSaving] = useState(false);

  const create = async () => {
    setSaving(true);
    setError(undefined);
    try {
      const created = await call<ProjectSummary>("/api/projects", {
        method: "POST",
        body: JSON.stringify({ name, jiraProjectKey: jiraProjectKey.toUpperCase(), jiraBaseUrl }),
      });
      navigate(`/projects/${created.projectId}/setup`);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="page-header">
        <h1>Create project</h1>
        <p>You will be set as administrator on the new project.</p>
      </div>
      <div className="card">
        <div className="field">
          <label>Project name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="field">
          <label>Jira project key</label>
          <input
            value={jiraProjectKey}
            onChange={(e) => setJiraProjectKey(e.target.value.toUpperCase())}
            placeholder="ELEM"
          />
        </div>
        <div className="field">
          <label>Jira base URL</label>
          <input value={jiraBaseUrl} onChange={(e) => setJiraBaseUrl(e.target.value)} />
        </div>
        {error && <p className="error">{error}</p>}
        <div className="actions">
          <button className="secondary" onClick={() => navigate(-1)}>Cancel</button>
          <button disabled={saving || !name || !jiraProjectKey} onClick={create}>
            {saving ? "Creating…" : "Create project"}
          </button>
        </div>
      </div>
    </>
  );
}
